import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { withRouter, RouteComponentProps } from 'react-router';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Spinner } from '../Spinner';
import { Pagination } from '../Pagination';
import { EventRow } from './components/EventRow';
import { AlertsActions } from '../../store';
import { IncidentListType, IncidentType } from '../../store/alerts/types';
import { SelectedBuilding, NavigationParamsType } from '../../store/building/types';
import { SearchBar } from '../SearchBar';
import { Notification } from '../Notification';
import { EventLogModal } from './components/EventLogModal';
import './EventLog.css';
import { ConnectedEventInformationDashboardWithRouter } from './components/EventInformationDashboard';
import { Checkbox } from '../Checkbox';

export interface Props {
  isLoading: boolean;
  allIncidents: IncidentListType;
  navigationParams: NavigationParamsType;
  loadAllIncidents(identifier: string, pageSize?: string, pageNumber?: string, unresolvedOnly?: boolean): void;
  selectedBuilding: SelectedBuilding;
  resolveIncident(apiLocation: string, reason: string): Promise<any>;
}

export declare type ComposedProps = Props & RouteComponentProps;

export interface State {
  selectedIncidents: string[];
  currentPage: number;
  filters: {};
  filteredIncidentsList: IncidentType[];
  isDetailPageOpen: boolean;
  apiLocationForIncident: string;
  isModalOpen: boolean;
  resolveApiLocation: string;
}

const incidentsPerPage = window.innerWidth > 599 ? '20' : '5';

export class EventLog extends Component<ComposedProps, State> {
  state = {
    selectedIncidents: [] as string[],
    currentPage: 1,
    filters: { showResolved: false, searchValue: '' },
    filteredIncidentsList: [],
    isDetailPageOpen: false,
    apiLocationForIncident: '',
    isModalOpen: false,
    resolveApiLocation: '',
  };

  async componentDidMount() {
    const {
      loadAllIncidents,
      selectedBuilding: { identifier },
    } = this.props;

    await loadAllIncidents(identifier, incidentsPerPage, '1', false);
    this.updateFilteredIncidentsList();
  }

  handleCheckboxChange = async () => {
    const {
      loadAllIncidents,
      selectedBuilding: { identifier },
    } = this.props;
    const filters = { ...this.state.filters };

    await this.setState(
      (state) => ({
        ...state,
        filters: {
          ...filters,
          showResolved: !filters.showResolved,
        },
      }),
      () => loadAllIncidents(identifier, incidentsPerPage, '1', this.state.filters.showResolved),
    );

    this.updateFilteredIncidentsList();
  };

  updateSearchValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.persist();
    this.setState(
      (state) => ({
        ...state,
        filters: {
          ...state.filters,
          searchValue: e.target.value,
        },
      }),
      () => this.updateFilteredIncidentsList(),
    );
  };

  // updateSortValue = (sortValue: string) => {
  //   const isReversed = sortValue === this.state.filters.sortValue && !this.state.filters.isReversed;

  //   this.setState(
  //     (state) => ({
  //       ...state,
  //       filters: {
  //         ...state.filters,
  //         isReversed,
  //         sortValue,
  //       },
  //     }),
  //     () => this.updateFilteredIncidentsList(),
  //   );
  // };

  updateFilteredIncidentsList = () => {
    const { filters, filteredIncidentsList } = this.state;
    const { allIncidents } = this.props;
    let tempIncidentsList = filteredIncidentsList.length > 0 ? filteredIncidentsList : allIncidents.results;

    if (filters.searchValue) {
      tempIncidentsList = tempIncidentsList.filter((incident) =>
        incident.name.replace(/\s/g, '').toLowerCase().includes(filters.searchValue.replace(/\s/g, '').toLowerCase()),
      );
    } else {
      tempIncidentsList = allIncidents.results;
    }

    if (!filters.showResolved) {
      tempIncidentsList = tempIncidentsList.filter((incident) => incident.is_resolved === false);
    }

    // const { sortValue, isReversed } = filters;

    // switch (sortValue) {
    //   case 'EVENT':
    //     // if this is the first time sorting, or if the previous sort is not by event
    //     if (!isReversed) {
    //       tempIncidentsList = tempIncidentsList.sort((a, b) => {
    //         if (a.name < b.name) return -1;
    //         if (a.name > b.name) return 1;
    //         return 0;
    //       });
    //       break;
    //     }
    //     // previous sort is also by event, we will sort in reverse
    //     tempIncidentsList = tempIncidentsList.sort((a, b) => {
    //       if (a.name > b.name) return -1;
    //       if (a.name < b.name) return 1;
    //       return 0;
    //     });
    //     break;
    //   case 'TIME':
    //     // if this is the first time sorting, or if the previous sort is not by occurences
    //     if (!isReversed) {
    //       tempIncidentsList = tempIncidentsList.sort((a, b) => {
    //         if (a.last_seen_timestamp < b.last_seen_timestamp) return -1;
    //         if (a.last_seen_timestamp > b.last_seen_timestamp) return 1;
    //         return 0;
    //       });
    //       break;
    //     }
    //     // previous sort is also by occurences, we will sort in reverse
    //     tempIncidentsList = tempIncidentsList.sort((a, b) => {
    //       if (a.last_seen_timestamp > b.last_seen_timestamp) return -1;
    //       if (a.last_seen_timestamp < b.last_seen_timestamp) return 1;
    //       return 0;
    //     });
    //     break;
    //   case 'OCCURRENCES':
    //     // if this is the first time sorting, or if the previous sort is not by occurences
    //     if (!isReversed) {
    //       tempIncidentsList = tempIncidentsList.sort((a, b) => {
    //         if (a.occurrences < b.occurrences) return -1;
    //         if (a.occurrences > b.occurrences) return 1;
    //         return 0;
    //       });
    //       break;
    //     }
    //     // previous sort is also by occurences, we will sort in reverse
    //     tempIncidentsList = tempIncidentsList.sort((a, b) => {
    //       if (a.occurrences > b.occurrences) return -1;
    //       if (a.occurrences < b.occurrences) return 1;
    //       return 0;
    //     });
    //     break;
    // }

    this.setState((state) => ({
      ...state,
      filteredIncidentsList: tempIncidentsList,
    }));
  };

  openIncident = (incidentId: string) => {
    const {
      navigationParams: {
        selectedSubCategory: { url: selectedSubCategoryUrl },
      },
    } = this.props;

    this.props.history.push(`${selectedSubCategoryUrl}?id=${incidentId}`);
  };

  openModal = (apiLocation: string) => {
    this.setState((state) => ({
      ...state,
      isModalOpen: true,
      resolveApiLocation: apiLocation,
    }));
  };

  closeModal = () => {
    this.setState((state) => ({
      ...state,
      isModalOpen: false,
      resolveApiLocation: '',
    }));
  };

  resolveIncident = (reason: string) => {
    const {
      resolveIncident,
      loadAllIncidents,
      selectedBuilding: { identifier },
    } = this.props;
    const { resolveApiLocation } = this.state;

    const incidentResolved = resolveIncident(resolveApiLocation, reason);

    if (incidentResolved) {
      toast.success('Incident successfully resolved!');
    } else {
      toast.error('Could not resolve incident');
    }

    this.setState(
      (state) => ({
        ...state,
        isModalOpen: false,
        resolveApiLocation: '',
      }),
      () => loadAllIncidents(identifier),
    );
  };

  changePage = (num: number) => {
    const {
      loadAllIncidents,
      selectedBuilding: { identifier },
    } = this.props;

    this.setState(
      (state) => ({
        ...state,
        currentPage: num,
      }),
      () => loadAllIncidents(identifier, incidentsPerPage, num.toString(), this.state.filters.showResolved),
    );
  };

  renderIncidents() {
    const {
      allIncidents: { results: incidentList },
    } = this.props;

    const { filteredIncidentsList, filters } = this.state;

    // initially the filteredRegisterList is empty
    const incidentsList =
      filteredIncidentsList.length === 0 && !filters.searchValue && filters.showResolved
        ? incidentList
        : filteredIncidentsList;

    // logic for displaying incidents
    // const incidentsPerPage = window.innerWidth > 599 ? 10 : 5;
    // const indexOfLastIncident = currentPage * incidentsPerPage;
    // const indexOfFirstIncident = indexOfLastIncident - incidentsPerPage;
    // const currentIncidents = incidentsList.slice(indexOfFirstIncident, indexOfLastIncident);

    if (incidentsList.length === 0) {
      return (
        <div className="alert-admin__no-alerts-message">
          <Notification message="There are currently no incidents for this building." type="success" />
        </div>
      );
    }

    return (
      <div>
        {incidentsList.map((incident) => {
          const {
            uid_hash,
            name,
            severity,
            event_count,
            last_seen_timestamp,
            is_resolved,
            resolution_api_location,
          } = incident;

          const formattedDate = moment(last_seen_timestamp).fromNow();
          return (
            <EventRow
              id={uid_hash}
              lastSeen={formattedDate}
              resolved={is_resolved}
              eventTitle={name}
              severity={severity}
              events={event_count}
              onIncidentOpen={() => this.openIncident(uid_hash)}
              onResolve={() => this.openModal(resolution_api_location)}
            />
          );
        })}
      </div>
    );
  }

  render() {
    const { isLoading, allIncidents, location } = this.props;
    const {
      filters: { showResolved, searchValue },
      isModalOpen,
    } = this.state;

    const columnNameClass = 'event-log__column-name';

    if (isLoading || Object.keys(allIncidents).length === 0) {
      return (
        <div className="event-log">
          <div className="event-log__header">
            <div className="event-log__title">Event Log</div>
            <SearchBar
              value={searchValue}
              placeholderText="Search for a specific incident"
              onChange={(e) => this.updateSearchValue(e)}
            />
          </div>
          <Spinner />
        </div>
      );
    }

    if (location.search) {
      return <ConnectedEventInformationDashboardWithRouter />;
    }

    return (
      <div className="event-log">
        <ToastContainer />
        <div className="event-log__header">
          <div className="event-log__title">Incident Log</div>
        </div>
        <div className="event-log__filters">
          <div className="event-log__search">
            <SearchBar
              value={searchValue}
              placeholderText="Search for a specific incident"
              onChange={(e) => this.updateSearchValue(e)}
            />
          </div>
          <div className="event-log__active-only">
            <span className="event-log__active-only-text">Show only unresolved?</span>
            <Checkbox checked={!showResolved} id="active-only" onChange={this.handleCheckboxChange} />
          </div>
        </div>
        <div className="event-log__column-names">
          {/* <button
            id="event"
            className={sortValue === 'EVENT' ? `${columnNameClass} event-log__column-name--selected` : columnNameClass}
            onClick={() => this.updateSortValue('EVENT')}
          >
            <span className="event-log__column-name-text event-log__column-name-text--wide">NAME</span>
            <ColumnArrow value="EVENT" sortValue={sortValue} isReversed={isReversed} />
          </button>
          <span className="event-log__column-name-text">LAST SEEN</span>
          <button
            id="occurrences"
            className={
              sortValue === 'OCCURRENCES' ? `${columnNameClass} event-log__column-name--selected` : columnNameClass
            }
            onClick={() => this.updateSortValue('OCCURRENCES')}
          >
            <span className="event-log__column-name-text">EVENTS</span>
            <ColumnArrow value="OCCURRENCES" sortValue={sortValue} isReversed={isReversed} />
          </button> */}
          <span className="event-log__column-name-text">NAME</span>
          <span className="event-log__column-name-text">LAST SEEN</span>
          <span className="event-log__column-name-text">EVENTS</span>
          <span className="event-log__column-name-text">SEVERITY</span>
          <span className="event-log__column-name-text">RESOLVED</span>
          <span className="event-log__column-name-text">ACTIONS</span>
        </div>
        {isLoading ? (
          <div className="event-log-loader">
            <Spinner />
          </div>
        ) : (
          this.renderIncidents()
        )}
        <Pagination
          currentPage={this.state.currentPage}
          itemsPerPage={parseInt(incidentsPerPage)}
          numberOfItems={allIncidents.count}
          onClick={this.changePage}
        />
        {isModalOpen ? <EventLogModal onConfirm={this.resolveIncident} onClose={this.closeModal} /> : null}
      </div>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    allIncidents: state.alertsReducer.allIncidents,
    isLoading: state.alertsReducer.isLoading,
    selectedBuilding: state.buildingReducer.selectedBuilding,
    navigationParams: state.buildingReducer.navigationParams,
  };
}

const mapDispatchToProps = {
  loadAllIncidents: AlertsActions.loadAllIncidents,
  resolveIncident: AlertsActions.resolveIncident,
};

const EventLogWithRouter = withRouter<ComposedProps>(EventLog);
export const ConnectedEventLogWithRouter = connect(mapStateToProps, mapDispatchToProps)(EventLogWithRouter);
